import { render, staticRenderFns } from "./Motors.vue?vue&type=template&id=00868434"
import script from "./Motors.vue?vue&type=script&lang=js"
export * from "./Motors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports